import { Icon } from '@/shared/ui/icon';
import './product-detail.scss';

type Props = {
    points?: number;
};
export const ProductDetailInfoCoupon = ({ points }: Props) => {
    if (!points) {
        return null;
    }

    return (
        <div className="product-detail__info-coupon" data-testid="product-detail-coupon">
            <Icon name="coupon" width={30} height={30} />
            <span data-testid="product-detail-coupon-points" data-value={points}>
                Za koupi získáte <strong>+{points} b.</strong>
            </span>
        </div>
    );
};
